import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {map, catchError, of} from 'rxjs';

import {AuthenticationDaoService} from '../../authentication/services/authentication-dao.service';

export const twoFARequiredGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationDaoService);
  const router = inject(Router);
  const translateService = inject(TranslateService);

  return authService.get2FAStatus().pipe(
    map(status => {
      if (!status.required || status.enabled) {
        return router.createUrlTree(['t'], {
          relativeTo: null
        });
      }

      return true;
    }),
    catchError(() => {
      const errorMessage = translateService.instant('TWO_FA.GUARD_FAIL');

      console.error(errorMessage);

      return of(true);
    })
  );
};
